  <div class="container-fluid-0px">
    <div class="row">
      <div class="col-12 px-4">
        <h5 class="my-3" i18n="@@InfomationStatusHeader">
          Notizen
        </h5>
      </div>
      <div class="col-12 px-4">
        <div class="chat-messages">
          <div *ngFor="let msg of messages; let i = index" class="chat-message">
            <div class="chat-message-text">
              <span>{{ msg.content }}</span>
              <small class="chat-timestamp">
               {{ msg.author }}: {{ msg.timestamp | date:'shortTime' }}
              </small>
            </div>
            <button class="chat-button" (click)="deleteMessage(i)" ngbTooltip="Notiz löschen">❌</button>
          </div>
        </div>

        <div class="chat-input">
          <input [(ngModel)]="newMessage" class="form-control" placeholder="Nachricht eingeben..." (keyup.enter)="sendMessage()" />
          <button class="btn-yellow" (click)="sendMessage()">Senden</button>
        </div>
      </div>

    </div>
  </div>
